import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { qk } from '@/lib/queryKeys';

export interface PondListItem {
  id: string;
  name: string;
}

interface PondPage {
  data: PondListItem[];
  meta?: { cursor?: string | null; has_more?: boolean | null };
}

export function usePonds(farmId: string | null | undefined) {
  return useQuery({
    queryKey: qk.ponds.list(farmId),
    queryFn: async () => {
      const ponds: PondListItem[] = [];
      let cursor: string | undefined;
      do {
        const params: Record<string, string> = { limit: '100' };
        if (cursor) params.cursor = cursor;
        const page = await api.get<PondPage>(`/api/v1/farms/${farmId}/ponds`, { params });
        ponds.push(...page.data);
        cursor = page.meta?.has_more ? (page.meta.cursor ?? undefined) : undefined;
      } while (cursor);
      return ponds;
    },
    enabled: !!farmId,
  });
}
